import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  const uniqueId = `paint0_linear_${Date.now()}_${Math.random()
    .toString(36)
    .slice(2)}`;
  return (
    <svg
      width={38}
      height={5}
      viewBox="0 0 38 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width={36}
        height={1}
        transform="matrix(-1 0 0 1 36 2)"
        fill={`url(#${uniqueId})`}
      />
      <path
        d="M35.0944 0.581645C35.1583 0.393095 35.425 0.393096 35.489 0.581645L35.8799 1.73428C35.8994 1.79173 35.943 1.83783 35.9992 1.86054L37.1048 2.30681C37.2786 2.37697 37.2786 2.62303 37.1048 2.69319L35.9992 3.13946C35.943 3.16217 35.8994 3.20827 35.8799 3.26572L35.489 4.41835C35.425 4.6069 35.1583 4.6069 35.0944 4.41835L34.7034 3.26572C34.6839 3.20827 34.6404 3.16217 34.5841 3.13946L33.4786 2.69319C33.3048 2.62303 33.3048 2.37697 33.4786 2.30681L34.5841 1.86054C34.6404 1.83783 34.6839 1.79173 34.7034 1.73428L35.0944 0.581645Z"
        fill={props.fill || "#C0DCFF"}
      />
      <defs>
        <linearGradient
          id={uniqueId}
          x1={0}
          y1={0.5}
          x2={36}
          y2={0.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={props.fill || "#C0DCFF"} />
          <stop
            offset={1}
            stopColor={props.fill || "#C0DCFF"}
            stopOpacity={0}
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgComponent;
